export default "__VITE_ASSET__DDQ6HOWS__"